export function formatLocalDateTime(utcIso) {
  if (!utcIso) return null;
  const d = new Date(utcIso);
  if (Number.isNaN(d.getTime())) return null;
  const datePart = d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  const timePart = d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  return `${datePart} · ${timePart}`;
}

export function formatLocalTime(utcIso) {
  if (!utcIso) return null;
  const d = new Date(utcIso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
}

export function formatDateBadge(stop) {
  if (!stop.date) return { month: "--", day: "--" };
  const start = new Date(`${stop.date}T00:00:00`);
  const month = start.toLocaleDateString(undefined, { month: "short" }).toUpperCase();
  if (stop.date_mode === "range" && stop.end_date) {
    const end = new Date(`${stop.end_date}T00:00:00`);
    return { month, day: `${start.getDate()}-${end.getDate()}` };
  }
  return { month, day: String(start.getDate()) };
}

export function formatPrice(currency, price) {
  if (price === null || price === undefined || price === "") return null;
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency: currency || "USD", maximumFractionDigits: 0 }).format(price);
  } catch {
    return `${price} ${currency || ""}`;
  }
}
